module.exports = __webpack_public_path__ + "static/media/left-bracket-key.9fe8875f.svg";